var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        "formulate-input-element formulate-input-element--" + _vm.context.type,
      attrs: { "data-type": _vm.context.type }
    },
    [
      _c("vue-editor", {
        staticClass: "editor",
        attrs: { "editor-toolbar": _vm.customToolbar },
        model: {
          value: _vm.context.model,
          callback: function($$v) {
            _vm.$set(_vm.context, "model", $$v)
          },
          expression: "context.model"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }